import * as React from "react";

function Table({color="#333",...props}) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M8.734 3.479H23M6.094 11.854a2.477 2.477 0 01-2.479 2.48 2.477 2.477 0 01-2.478-2.48 2.477 2.477 0 012.478-2.478 2.477 2.477 0 012.479 2.479zM23 11.854H8.734M1.1 3.479A2.477 2.477 0 013.578 1a2.482 2.482 0 012.479 2.479 2.477 2.477 0 01-2.479 2.478A2.47 2.47 0 011.1 3.48zM1 20.23a2.477 2.477 0 002.479 2.48 2.477 2.477 0 002.478-2.48 2.482 2.482 0 00-2.478-2.478A2.47 2.47 0 001 20.231zM8.734 20.231H23"
        stroke={color}
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default Table;
